export const generic = {
  loginUnreadableInputs: {
    text: "Désolé ! Impossible de se connecter à cause d'une erreur inattendue.",
    btnText: 'Se reconnecter',
    errorText: 'Erreur : ',
  },
  form: {
    mandatoryFields: '* : Champs obligatoires',
  },
  msgErrors: 'Erreur(s) dans le formulaire',
  loading: 'Chargement',
  btn: {
    validate: {
      label: 'Valider',
      title: 'Valider',
    },
    cancel: {
      label: 'Annuler',
      title: 'Annuler',
    },
  },
  dialog: {
    minimize: 'Minimiser',
    maximize: 'Maximiser',
    close: 'Fermer',
  },
  input: {
    password: {
      label: 'Mot de passe *',
      error: 'Merci de saisir le mot de passe...',
    },
    text: {
      label: 'Texte *',
      error: 'Merci de saisir le texte...',
    },
    secretCode: {
      label: 'Code secret *',
      error: 'Merci de saisir le code secret...',
    },
    placeholderTemplate: '{fieldLabel} : ',
    mandatoryPlaceholderTemplate: '{fieldLabel} : *',
    resetTemplate: 'Effacer : {resetLabel}',
    showTemplate: 'Afficher : {showLabel}',
    hideTemplate: 'Masquer : {hideLabel}',
  },
  dataSync: {
    success: 'Synchronisation des données...',
    dataLoading: 'Pré-chargement des dernières notes...',
    error: 'Erreur lors de la récupération des données : ',
  },
  unknown: 'inconnu',
  unknownError: 'Erreur inconnue',
  versionLabel: 'Version',
  sync: 'Données synchronisées avec succès !',
  goToTop: {
    page: 'Aller en haut de page',
    list: 'Aller en haut de liste',
  },
  default: 'défaut',
  beltLabel: {
    yellow: 'jaune',
    orange: 'orange',
    green: 'verte',
    blue: 'bleue',
    brown: 'marron',
    black: 'noire',
  },
  healthCheck: {
    backendNotReachable:
      'Serveur distant injoignable (pas de connexion à internet ou dysfonctionnement du serveur). Veuillez réessayer ultérieurement'  },
  hasToBeOnline:
    'Cette fonctionnalité nécessite que votre appareil soit connecté à internet.',
};
